<template>
  <div class="p-schedule-visit">
    <Stepper :step="step" :texts="$t('visits.schedule.steps')" />
    <div class="p-schedule-visit__content">
      <v-progress-linear v-if="loading" indeterminate color="primary" />
      <v-card v-else max-width="464px" class="p-schedule-visit__content__card" outlined>
        <FirstStep v-if="step === 1" @submit="nextStep" :mode="mode" />
        <SecondStep v-if="step === 2" @slotConflict="slotConflict" :mode="mode" :price="practitionerPrice" />
        <SuccessPayment v-if="step === 3" :session="session" />
        <ExpireError v-if="step === 4" />
      </v-card>
    </div>
    <Snackbar v-model="snackbar.value" :type="snackbar.type" :timeout="5000" :text="snackbar.text" />
  </div>
</template>
<script>
import { DateTime } from "luxon";
import { mapActions, mapGetters } from "vuex";

import { PractitionersAPI } from "@/api/practitioners";
import FirstStep from "@/components/Checkout/FirstStep/Index";
import ExpireError from "@/components/Checkout/PatientScheduleVisit/ExpireError";
import SecondStep from "@/components/Checkout/PatientScheduleVisit/SecondStep";
import SuccessPayment from "@/components/Checkout/SuccessPayement/Index";
import Snackbar from "@/components/shared/Snackbar";
import Stepper from "@/components/shared/Stepper";
import { snackBarEventBus, snackBarEventName } from "@/eventBuses/snackBar.eventBus";

export default {
  name: "PatientRequestVisit",
  components: {
    Stepper,
    FirstStep,
    SecondStep,
    Snackbar,
    SuccessPayment,
    ExpireError,
  },
  data: () => ({
    step: 1,
    mode: "create",
    loading: false,
    buttonLoading: false,
    snackbar: {
      value: false,
      text: "",
      type: "success",
    },
    practitionerPrice: null,
  }),
  computed: {
    ...mapGetters(["timeZone"]),
    ...mapGetters("checkout", ["slotId", "session"]),
    ...mapGetters("patient", ["patientsPractitioner"]),
  },
  methods: {
    ...mapActions("patient", ["getPatientProfile"]),
    ...mapActions("appointments", ["scheduleAppointment"]),
    ...mapActions("slots", ["getPractitionerFreeSlots", "getSlotById"]),
    ...mapActions("checkout", ["getSessionInfo", "preloadPatientProfile"]),
    nextStep(nextStep) {
      this.step = nextStep;
    },
    async slotConflict() {
      this.step = 1;
      await this.getPractitionerFreeSlots();
    },
    async load() {
      const { sessionId, status } = this.$route.params;
      try {
        this.loading = true;
        if (sessionId) {
          this.mode = "edit";
          await this.getSessionInfo(sessionId);
          await this.getSlotById(this.slotId);

          // TODO refactor next check
          const date = DateTime.fromISO(this.session.rejectDate).toJSDate();
          const reducedDate = new Date(date.valueOf() - 3 * 60000);
          if (reducedDate < new Date()) {
            this.step = 4;
            return;
          }

          if ((status && status === "success") || this.session.status === "completed") {
            this.step = 3;
          }
        } else {
          await this.preloadPatientProfile();
        }

        await this.getPatientProfile();
        const results = await Promise.all([
          PractitionersAPI.practitionerGetSettings(this.patientsPractitioner.id),
          this.getPractitionerFreeSlots(),
        ]);
        this.practitionerPrice = results[0]?.price;
      } catch (err) {
        snackBarEventBus.$emit(snackBarEventName, {
          message: (err && err.response && err.response.data && err.response.data.message) || err,
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.load();
  },
  watch: {
    async $route() {
      await this.load();
    },
  },
};
</script>
